export const registerSchema = {
    type: "object",
    properties: {
        accessToken: { type: "string" },
        notifHost: { type: "string" },
        rtdHost: { type: "string" },
        rtdUrl: { type: "string", nullable: true },
        notifUrl: { type: "string", nullable: true },
        clientType: { type: "string" },
        lostConnectionRecoveryTimeout: { type: "string", nullable: true },
        notifsWelcomeFlag: { type: "boolean", nullable: true },
        welcomeTimeout: { type: "number", nullable: true },
        pingURL: { type: "string", nullable: true },
        pingEvent: { type: "string", nullable: true },
        httpHeaders: { type: "object" }
    },
    required: ["accessToken", "notifHost", "rtdHost", "clientType"],
    additionalProperties: false
};
export const registerSchemaV2 = {
    type: "object",
    properties: {
        accessToken: { type: "string" },
        apiGatewayHost: { type: "string" },
        clientType: { type: "string" },
        lostConnectionRecoveryTimeout: { type: "string", nullable: true },
        pingEvent: { type: "string", nullable: true },
        httpHeaders: { type: "object" }
    },
    required: ["accessToken", "apiGatewayHost", "clientType"],
    additionalProperties: false
};
export const subscribeSchema = {
    type: "object",
    properties: {
        datasetName: { type: "string" },
        update: { instanceof: "Function" },
        error: { instanceof: "Function" },
        connectionStatus: { instanceof: "Function" }
    },
    required: ["datasetName", "update"],
    additionalProperties: false
};
export const subscribeSchemaV2 = {
    type: "object",
    properties: {
        datasetName: { type: "string" },
        update: { instanceof: "Function" },
        error: { instanceof: "Function" },
        connectionStatus: { instanceof: "Function" },
        subscribeParams: { type: "object", nullable: true }
    },
    required: ["datasetName", "update"],
    additionalProperties: false
};
